// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53a2e09e","239":"427b25e2","455":"afa2547f","488":"7c51ed6d"}[chunkId] + ".chunk.js";
};